import vuetify from '@/plugins/vuetify'

const axisDateTimeLabelFormats = {
  millisecond: '%H:%M:%S.%L',
  second: '%H:%M:%S',
  minute: '%H:%M',
  hour: '%H:%M',
  day: '%e. %b',
  week: '%e. %b',
  month: "%b '%y",
  year: '%Y'
}

const tooltipDateTimeLabelFormats = {
  millisecond: '%e. %b %Y %H:%M:%S.%L',
  second: '%e. %b %Y %H:%M:%S',
  minute: '%e. %b %Y %H:%M',
  hour: '%e. %b %Y %H:%M',
  day: '%A, %e. %b %Y',
  week: '%e. %b %Y',
  month: '%b %Y',
  year: '%Y'
}

const dataGroupingDateTimeLabelFormats = {
  millisecond: [
    '%e. %b %Y %H:%M:%S.%L',
    '%e. %b %Y %H:%M:%S.%L',
    '-%H:%M:%S.%L'
  ],
  second: ['%e. %b %Y %H:%M:%S', '%e. %b %Y %H:%M:%S', '-%H:%M:%S'],
  minute: ['%e. %b %Y %H:%M', '%e. %b %Y %H:%M', '-%H:%M'],
  hour: ['%e. %b %Y %H:%M', '%e. %b %Y %H:%M', '-%H:%M'],
  day: ['%A, %e. %b %Y', '%A, %e. %b %Y', '-%A, %e. %b %Y'],
  week: ['%e. %b %Y', '%e. %b %Y', '-%e. %b %Y'],
  month: ['%b %Y', '%b %Y', '-%b %Y'],
  year: ['%Y', '%Y', '-%Y']
}

export function getHighchartsOptions() {
  const themeColors = vuetify.theme.current.value.colors

  return {
    time: {
      timezone: 'Europe/Oslo'
    },
    lang: JSON.parse(window.hs_lang),
    xAxis: {
      dateTimeLabelFormats: axisDateTimeLabelFormats
    },
    tooltip: {
      dateTimeLabelFormats: tooltipDateTimeLabelFormats
    },

    colors: [
      themeColors.charts0,
      themeColors.charts1,
      themeColors.charts2,
      themeColors.charts3,
      themeColors.charts4,
      themeColors.charts5,
      themeColors.charts6,
      themeColors.charts7,
      themeColors.charts8,
      themeColors.charts9,
      themeColors.charts10
    ].filter(Boolean),

    chart: {
      backgroundColor: themeColors.surface,
      style: {
        fontFamily: 'var(--font-body)',
        color: themeColors['on-background']
      }
    },
    title: {
      style: {
        fontFamily: 'var(--font-heading)',
        fontWeight: 'normal',
        color: themeColors['on-background']
      }
    },
    legend: {
      itemStyle: {
        color: themeColors['on-background']
      }
    },
    plotOptions: {
      series: {
        dataGrouping: {
          approximation: 'high',
          dateTimeLabelFormats: dataGroupingDateTimeLabelFormats
        }
      }
    }
  }
}
